var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useCallback, useRef, } from 'react';
import { isMobile } from 'react-device-detect';
import { useEventListener } from '@24i/player-utils-react';
import { Button } from '../Button/styled';
import { StyledIcon as PlayerIcon } from '../Icons';
const RenderDefaultIcon = (isPlayerPaused, disabled, backgroundColor, styles, variant) => {
    const isPodcast = variant === 'podcast';
    const playIcon = isPodcast ? 'onPrimary-control_play' : 'onDark-control_play';
    const pauseIcon = isPodcast ? 'onPrimary-control_pause' : 'onDark-control_pause';
    return (React.createElement(PlayerIcon, { style: Object.assign(Object.assign({}, styles.icon), { opacity: disabled ? 0.4 : 1 }), "data-test": "PlayPauseButton-Icon", className: "PlayPauseButton-Icon", name: isPlayerPaused ? playIcon : pauseIcon, backgroundColor }));
};
export const PlayPauseButton = ({ playerInstance, backgroundColor = 'transparent', className = '', customIcon = RenderDefaultIcon, disabled = false, styles = {
    button: null,
    icon: null,
}, onPlayPausePress, variant, }) => {
    const [isPlayerPaused, setIsPlayerPause] = useState(!(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.autoPlay));
    const button = useRef(null);
    const onPlaying = useCallback(() => {
        setIsPlayerPause(false);
    }, []);
    const onPause = useCallback(() => {
        setIsPlayerPause(true);
    }, []);
    const onKeyPress = useCallback((event) => {
        event.preventDefault();
    }, []);
    const onCanPlay = useCallback(() => {
        setIsPlayerPause(!(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.playing));
    }, [playerInstance]);
    useEventListener('playing', onPlaying, playerInstance);
    useEventListener('pause', onPause, playerInstance);
    useEventListener('keydown', onKeyPress, button.current);
    useEventListener('keyup', onKeyPress, button.current);
    useEventListener('emptied', onPause, playerInstance);
    useEventListener('canplay', onCanPlay, playerInstance);
    const onClickHandler = (event) => __awaiter(void 0, void 0, void 0, function* () {
        if (event)
            event.stopPropagation();
        if (!event ||
            (event.type === 'touchstart' && isMobile) ||
            (event.type === 'mousedown' && !isMobile)) {
            if (disabled)
                return;
            const preAction = onPlayPausePress || (() => Promise.resolve(false));
            const blockDefault = yield preAction(!isPlayerPaused);
            if (!blockDefault) {
                if (!isPlayerPaused) {
                    playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.pause();
                }
                else {
                    playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.play();
                }
            }
        }
    });
    return (React.createElement(Button, { ref: button, style: styles.button, "data-test": "PlayPauseButton-Button", testID: `${isPlayerPaused ? 'pause' : 'play'}_button`, className: `${className} PlayPauseButton-Button`, onTouchStart: onClickHandler, onMouseDown: onClickHandler, onDoubleClick: (event) => {
            event.stopPropagation();
            event.preventDefault();
        }, backgroundColor, disabled }, customIcon(isPlayerPaused, disabled, backgroundColor, styles, variant)));
};
//# sourceMappingURL=index.js.map